import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import RemoveForm from "pages/refill/RemoveForm";
import React from "react";

const RemoveDialog = ({ tray_id, open, handleClose, partition }) => {
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={() => {
        handleClose();
      }}
      heading="Remove product"
    >
      <Box sx={{ overflow: "hidden", padding: 2 }}>
        <RemoveForm partition={partition} fullGrid={true} />
      </Box>
    </CustomDialog>
  );
};

export default RemoveDialog;
